import { atom } from "jotai";
import { atomWithToggle } from "@/utils";
import { SidebarEnum } from "@/types";

export const navigationAtom = atom<SidebarEnum | null>(SidebarEnum.MISSIONS);
export const sidebarVisibilityAtom = atomWithToggle(true);
export const activePanelAtom = atom<string | null>(null);
export const aboutPanelVisibilityAtom = atomWithToggle(false);
